import React, { useCallback, useEffect, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddPermission from "./AddPermission";
import { Permission_Table_Head } from "../../components/datagrid/permissions/PermissionTableHead";
import {
  getAlldepartments,
  getallPermissions,
  getPermissions,
} from "../../redux/features/permissionSlice";
import UpdatePermission from "./UpdatePermission";
import Permissionrelation from "./Permissionrelation";
import DeletePermission from "./DeletePermission";
import RelationShipView from "./RelationShipView";

const Permissions = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { permissionData, loading, departments } = useSelector(
    (state) => state.permission
  );
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [value, setValue] = useState(dayjs());

  const [department, setdepartment] = useState([]);

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search,
    department: department,
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getallPermissions(data));
    }
  }, [pageNum, gridSize, search, department]);

  useEffect(() => {
    dispatch(getAlldepartments());
  }, []);

  const handledepartment = useCallback((event, value) => {
    const dept_id = value?.dept_id || "";
    setdepartment(dept_id);
  }, []);

  return (
    <GlobalWrapper
      title={"Permissions"}
      actions={<AddPermission dispatchparams={data} />}
    >
      <Box sx={{ width: "100%", padding: 0, marginBottom: 2 }}>
        <Autocomplete
          disablePortal
          options={departments}
          sx={{ width: 300 }}
          onChange={handledepartment}
          getOptionLabel={(option) => option?.dept_name || ""}
          value={departments.find((d) => d.dept_id === department) || null}
          renderInput={(params) => <TextField {...params} label="Department" />}
        />
      </Box>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Permission_Table_Head}
          rows={permissionData.data}
          meta={permissionData?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.title} />
              <GlobalAnchorList
                label=""
                component={
                  <UpdatePermission rowData={rowData} dispatchparams={data} />
                }
              />
              <GlobalAnchorList
                label=""
                component={
                  <DeletePermission
                    id={rowData?.permissionID}
                    dispatchdata={data}
                  />
                }
              />
              <GlobalAnchorList
                label=""
                component={
                  <Permissionrelation
                    department={rowData?.dept_id}
                    permission={rowData?.permissionID}
                  />
                }
              />
              <GlobalAnchorList
                label="Relationship"
                component={<RelationShipView rowData={rowData} />}
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Permissions;
